import React from 'react';
import { PropTypes } from 'prop-types';
import { Text } from '@ps-design-system/components/Text';
import { Input } from '@ps-design-system/components/Input';
import useCalendarSyncFlowStore from '../../../store/sync-flow/useCalendarSyncFlowStore';
import ICalendarSyncStrings from './strings';
import { injectIntl } from 'react-intl';

const ICalendarSync = ({ intl }) => {
  const setICalName = useCalendarSyncFlowStore((state) => state.setICalName);
  const setICalUrl = useCalendarSyncFlowStore((state) => state.setICalUrl);
  const iCalUrlError = useCalendarSyncFlowStore((state) => state.iCalUrlError);
  const iCalNameError = useCalendarSyncFlowStore((state) => state.iCalNameError);

  return (
    <div className="ICalendarSync">
      <Text typeface="body-2">
        {ICalendarSyncStrings.instructions}
      </Text>

      <div className="ICalendarSync_input-container">
        <Text typeface="body-2-m" className="ICalendarSync_label">
          {ICalendarSyncStrings.nameInputLabel}
        </Text>
        <Input
          className="ICalendarSync_input"
          placeholder={intl.formatMessage(ICalendarSyncStrings.placeholders.nameInput)}
          onChange={(e) => setICalName(e.target.value)}
          errorMsg={iCalNameError}
        />
        {iCalNameError && (
          <Text typeface="body-2" className="ICalendarSync_error">
            {iCalNameError}
          </Text>
        )}
      </div>

      <div className="ICalendarSync_input-container">
        <Text typeface="body-2-m" className="ICalendarSync_label">
          {ICalendarSyncStrings.urlInputLabel}
        </Text>
        <Input
          className="ICalendarSync_input"
          placeholder={intl.formatMessage(ICalendarSyncStrings.placeholders.urlInput)}
          onChange={(e) => setICalUrl(e.target.value)}
          errorMsg={iCalUrlError}
        />
        {iCalUrlError && (
          <Text typeface="body-2" className="ICalendarSync_error">
            {iCalUrlError}
          </Text>
        )}
      </div>
    </div>
  );
};

ICalendarSync.propTypes = {
  intl: PropTypes.object.isRequired
};

export default injectIntl(ICalendarSync);
